import {Component, Input, OnInit} from '@angular/core';
import {InformationDossierTableMetierService} from './information-dossier-table.metier.service';
import {Autowired} from '@angular-ru/autowired';
import {SgiListLayoutComponent} from '@shared/behaviors/list-layout/sgi/sgi-list-layout.component';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-information-dossier-table',
  templateUrl: './information-dossier-table.component.html'
})

export class InformationDossierTableComponent extends SgiListLayoutComponent implements OnInit {
  @Autowired() recuperationListeDonneesMetier: InformationDossierTableMetierService;
  @Autowired() metierService: InformationDossierTableMetierService;

  @Input() modalAssureSelected: any;

  adherentForm: FormGroup;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.initFormulaire();
  }

  /**
   * Définition des arguments
   */
  defineArgs(): void {
    super.defineArgs();
    const arg = {...this.args, };
    this.args = {...arg};
  }

  initFormulaire() {
    this.adherentForm = this.metierService.initialiserFormulaireAssure(this.modalAssureSelected);
  }

}
